import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Success() {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen flex flex-col">
			<div className="h-64 w-full flex flex-row justify-center items-center bg-gradient-to-r from-[#0255A9] to-[#03AAEE]">
				<img src="/logo-white.png" width={150} height={30} alt="my-logo" />
			</div>
			<div className="h-full flex-grow flex flex-col justify-center items-center ">
				<main className="p-8 flex flex-col items-center w-full mt-32">
					<p className="text-xl font-semibold" style={{ textAlign: 'center' }}>
						Thank you for submitting your form
					</p>
					<div className="p-8 w-3/4 flex flex-col items-center mt-16" style={{ padding: '10px 50px 10px 50px' }}>
						<Button variant="contained" color="primary" onClick={() => navigate('/')}>
							Back to Home
						</Button>
					</div>
				</main>
			</div>
			<div className="h-32 mt-32 w-full flex flex-row justify-center items-center bg-gradient-to-r from-[#0255A9] to-[#03AAEE]">
				<a
					href="https://bluefit.com.au"
					target="_blank"
					rel="noreferrer"
					className="text-white hover:text-blue-400"
				>
					BlueFit.com.au
				</a>
			</div>
		</div>
	);
}
